import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

import "./i18n";

ReactDOM.render(
  <App />,
  document.getElementById("root")
);